enum DocumentVersionCreator {
  User = "User",
  Migration = "Migration",
  Assistant = "Assistant",
}
export default DocumentVersionCreator;
